import { render, staticRenderFns } from "./imapConfig.vue?vue&type=template&id=385f0100&scoped=true&"
import script from "./imapConfig.vue?vue&type=script&lang=js&"
export * from "./imapConfig.vue?vue&type=script&lang=js&"
import style0 from "./imapConfig.vue?vue&type=style&index=0&id=385f0100&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385f0100",
  null
  
)

export default component.exports